<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>作废订单</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
          <el-row :gutter="20">
            <el-col :span="3">
              <el-tooltip class="item" effect="light" content="订单编号" placement="top">
                <el-input v-model="queryInfo.orderNo" placeholder="订单编号" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="5" style="margin-left: -2%;">
              <el-date-picker
                v-model="scopeDateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="接单"
                end-placeholder="时间"
                size="mini"
                style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="margin-left: -0%;">
              <el-tooltip class="item" effect="light" content="请选择订单状态" placement="top">
                <el-select v-model="queryInfo.orderStatus" placeholder="订单状态" size="mini">
                  <el-option label="全部订单状态" value=""></el-option>
                  <el-option label="预备订单" value="预备订单"></el-option>
                  <el-option label="受理订单" value="受理订单"></el-option>
                  <el-option label="报价完成" value="报价完成"></el-option>
                  <el-option label="等待生产" value="等待生产"></el-option>
                  <el-option label="生产开始" value="生产开始"></el-option>
                  <el-option label="检验完成" value="检验完成"></el-option>
                  <el-option label="生产完成" value="生产完成"></el-option>
                  <el-option label="库存订单" value="库存订单"></el-option>
                  <el-option label="准备出库" value="准备出库"></el-option>
                  <el-option label="订单出库" value="订单出库"></el-option>
                  <el-option label="运输外包" value="运输外包"></el-option>
                  <el-option label="异常订单" value="异常订单"></el-option>
                  <el-option label="订单处理" value="订单处理"></el-option>
                  <el-option label="订单完成" value="订单完成"></el-option>
                  <el-option label="订单外包" value="订单外包"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="3" style="margin-left: -1%;">
              <el-tooltip class="item" effect="light" content="产品名称" placement="top">
                <el-input v-model="queryInfo.productName" placeholder="产品名称" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="请选择订单类型" placement="top">
                <el-select v-model="queryInfo.orderType" placeholder="订单类型" size="mini">
                  <el-option label="普通订单" value="普通订单"></el-option>
                  <el-option label="加急订单" value="加急订单"></el-option>
                  <el-option label="库存订单" value="库存订单"></el-option>
                  <el-option label="出库订单" value="出库订单"></el-option>
                  <el-option label="返工订单" value="返工订单"></el-option>
                  <el-option label="退货订单" value="退货订单"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="2" >
              <el-tooltip class="item" effect="light" content="订货店铺" placement="top">
                <el-input v-model="queryInfo.shop" placeholder="订货店铺" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="客户ID" placement="top">
                <el-input v-model="queryInfo.customerId" placeholder="客户ID" size="mini" style="width: 80%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="客户姓名" placement="top">
                <el-input v-model="queryInfo.customerName" placeholder="客户姓名" size="mini" style="width: 80%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="客户电话" placement="top">
                <el-input v-model="queryInfo.customerPhone" placeholder="客户电话" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="客户地址" placement="top">
                <el-input v-model="queryInfo.customerAddr" placeholder="客户地址" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="1" style="margin-left: -1%;">
              <el-tooltip class="item" effect="light" content="搜索或保留条件刷新,可在页面中使用回车键代替" placement="top">
                <el-button icon="el-icon-search" circle size="mini" @click="search()"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          
          <el-row style="margin-top: 0.5%;">
            <el-col :span="2">
              <el-button type="primary" size="mini" @click="restoreOrder()" :disabled="!pagePermissionObj.restoreOrder">还原订单</el-button>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-button type="danger" size="mini" @click="fullyClearOrder()" :disabled="!pagePermissionObj.fullyClearOrder">完全清除订单</el-button>
            </el-col>
            <el-col :span="2" style="margin-left: -0%;">
              <el-button type="info" plain size="mini" @click="exportExcle()" :disabled="!pagePermissionObj.restoreOrderExportExcle">导出Excle</el-button>
            </el-col>
            
            <el-col :span="2" style="margin-left: -0%;">
              <el-button type="info" plain size="mini" @click="displayColumnSettings()">展示列设置</el-button>
            </el-col>
            
            <el-col :span="4" style="margin-left: 14%;">
              <el-tooltip class="item" effect="light" content="作废说明" placement="top">
                <el-input v-model="queryInfo.cancelExp" placeholder="作废说明" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="5" style="margin-left: -1%;">
              <el-date-picker
                v-model="scopeCancelTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="作废"
                end-placeholder="时间"
                size="mini"
                style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col :span="3" style="margin-left: 1%;">
              <el-tooltip class="item" effect="light" content="作废人" placement="top">
                <el-input v-model="queryInfo.cancelPerson" placeholder="作废人" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
          </el-row>
          
          <el-table max-height="630" :data="orderList" border style="width: 100%" size="mini"
            ref="multipleTable" tooltip-effect="dark" :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange" @header-click="headerClick"
            @row-click="handleRowClick" @row-dblclick="rowDoublelClick">
            <el-table-column type="selection" width="37"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="orderNo" label="订单编号" width="180%" v-if="displayColumnSettingsObject.orderNo"></el-table-column>
            <el-table-column prop="cancelExp" label="作废说明" width="200%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.cancelExp"></el-table-column>
            <el-table-column prop="cancelTime" label="作废时间" width="150%" v-if="displayColumnSettingsObject.cancelTime"></el-table-column>
            <el-table-column prop="cancelPerson" label="作废人" v-if="displayColumnSettingsObject.cancelPerson"></el-table-column>
            <el-table-column prop="orderDateTime" label="接单时间" width="150%" v-if="displayColumnSettingsObject.orderDateTime"></el-table-column>
            <el-table-column prop="productName" label="产品名称" width="190%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.productName"></el-table-column>
            <el-table-column prop="speModel" label="规格型号" width="130%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.speModel"></el-table-column>
            <el-table-column prop="colour" label="颜色" width="150%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.colour"></el-table-column>
            <el-table-column prop="sheetMaterial" label="板材材料" width="128%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.sheetMaterial"></el-table-column>
            <el-table-column prop="orderStatus" label="订单状态" width="80%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.orderStatus">
              <template slot-scope="scope">
                 <span v-if="scope.row.pushComCode !== null && scope.row.pushComCode !== 0">{{scope.row.orderStatus + "(外包订单状态)"}}</span>
                 <span v-if="scope.row.pushComCode == null || scope.row.pushComCode == 0">{{scope.row.orderStatus}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="orderType" label="订单类型" v-if="displayColumnSettingsObject.orderType"></el-table-column>
            <el-table-column prop="pickUpGoodsPhone" label="提货电话" width="100%" v-if="displayColumnSettingsObject.pickUpGoodsPhone"></el-table-column>
            <el-table-column prop="deliveryDate" label="发货日期" width="100%" v-if="displayColumnSettingsObject.deliveryDate">
              <template slot-scope="scope">
                 <span v-if="deliveryDateExpire(scope.row)" style="color: blue;">{{scope.row.deliveryDate}}</span>
                 <span v-if="!deliveryDateExpire(scope.row)">{{scope.row.deliveryDate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" label="套数" v-if="displayColumnSettingsObject.quantity"></el-table-column>
            <el-table-column prop="shop" label="订货店铺" v-if="displayColumnSettingsObject.shop"></el-table-column>
            <el-table-column prop="shippingClerk" label="发货员" v-if="displayColumnSettingsObject.shippingClerk"></el-table-column>
            <el-table-column prop="shopPhone" label="订货电话" width="100%" v-if="displayColumnSettingsObject.shopPhone"></el-table-column>
            <el-table-column prop="shipAddr" label="店铺地址"  show-overflow-tooltip=false v-if="displayColumnSettingsObject.shipAddr"></el-table-column>
            <el-table-column prop="customerId" label="客户ID" width="100%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.customerId"></el-table-column>
            <el-table-column prop="customerName" label="客户姓名" width="90%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.customerName"></el-table-column>
            <el-table-column prop="customerPhone" label="客户电话" width="100%" v-if="displayColumnSettingsObject.customerPhone"></el-table-column>
            <el-table-column prop="customerAddr" label="客户地址" width="200%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.customerAddr"></el-table-column>
            <el-table-column prop="customerBuy" label="第几次购买" width="82%" v-if="displayColumnSettingsObject.customerBuy"></el-table-column>
            <el-table-column prop="payTime" label="付款时间" width="150%" v-if="displayColumnSettingsObject.payTime"></el-table-column>
            <el-table-column prop="installRequirements" label="安装要求" show-overflow-tooltip=false v-if="displayColumnSettingsObject.installRequirements"></el-table-column>
            <el-table-column prop="remarks" label="备注" width="200%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.remarks"></el-table-column>
            <el-table-column prop="orderReceivPerson" label="接单客服" v-if="displayColumnSettingsObject.orderReceivPerson" width="100%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="billingPerson" label="开单员" v-if="displayColumnSettingsObject.billingPerson" width="100%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="productionDate" label="生产日期" width="100%" v-if="displayColumnSettingsObject.productionDate"></el-table-column>
            <el-table-column prop="finishDateTime" label="完成时间" v-if="displayColumnSettingsObject.finishDateTime"></el-table-column>
            <el-table-column prop="outputTime" label="出库时间" width="150%" v-if="displayColumnSettingsObject.outputTime"></el-table-column>
            <el-table-column prop="boxNum" label="打包数" v-if="displayColumnSettingsObject.boxNum"></el-table-column>
            <el-table-column prop="woodNum" label="打框数" v-if="displayColumnSettingsObject.woodNum"></el-table-column>
            <el-table-column prop="abnormalClass" label="异常类型" v-if="displayColumnSettingsObject.abnormalClass"></el-table-column>
            <el-table-column prop="abnormalDesc" label="异常描述" width="200%" show-overflow-tooltip=false v-if="displayColumnSettingsObject.abnormalDesc"></el-table-column>
            <el-table-column prop="inventory" label="库存数" v-if="displayColumnSettingsObject.inventory"></el-table-column>
            <el-table-column prop="partsNum" label="配件数量" v-if="displayColumnSettingsObject.partsNum"></el-table-column>
            <el-table-column prop="cabinetArea" label="柜体面积" v-if="displayColumnSettingsObject.cabinetArea"></el-table-column>
            <el-table-column prop="unitPrice" label="单价" v-if="displayColumnSettingsObject.unitPrice"></el-table-column>
            <el-table-column prop="cabinetCost" label="柜体费用" v-if="displayColumnSettingsObject.cabinetCost"></el-table-column>
            <el-table-column prop="metalsCost" label="五金费用" v-if="displayColumnSettingsObject.metalsCost"></el-table-column>
            <el-table-column prop="outsideProductCost" label="外采费用" v-if="displayColumnSettingsObject.outsideProductCost"></el-table-column>
            <el-table-column prop="installCost" label="安装费用" v-if="displayColumnSettingsObject.installCost"></el-table-column>
            <el-table-column prop="packCost" label="物流费用" v-if="displayColumnSettingsObject.packCost"></el-table-column>
            <el-table-column prop="subjoinCost" label="附加费" v-if="displayColumnSettingsObject.subjoinCost"></el-table-column>
            <el-table-column prop="doorPlankArea" label="门板面积" v-if="displayColumnSettingsObject.doorPlankArea"></el-table-column>
            <el-table-column prop="totalMoney" label="订单金额" v-if="displayColumnSettingsObject.totalMoney"></el-table-column>
            <el-table-column prop="paymentMethod" label="付款方式" v-if="displayColumnSettingsObject.paymentMethod"></el-table-column>
            <el-table-column prop="prepay" label="现付" v-if="displayColumnSettingsObject.prepay"></el-table-column>
            <el-table-column prop="monthBond" label="月结" v-if="displayColumnSettingsObject.monthBond"></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="80%">
              <template slot-scope="scope">
                <el-button type="info" size="mini" @click="orderInfo(scope.$index, scope.row)">详情</el-button>
              </template>
            </el-table-column>
            
          </el-table>
    
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[10,20,50,100,200,500]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
          
        </el-card>
        
        <div>
          <!-- 展示列设置模态窗口 -->
          <el-dialog title="展示列设置" :visible.sync="displayColumnSettingsDialogVisible">
            <div>
              <el-checkbox v-model="displayColumnSettingsObject.orderNo">订单编号</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.cancelExp">作废说明</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.cancelTime">作废时间</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.cancelPerson">作废人</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.orderDateTime">接单时间</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.productName">产品名称</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.speModel">规格型号</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.colour">颜色</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.sheetMaterial">板材材料</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.orderStatus">订单状态</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.orderType">订单类型</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.pickUpGoodsPhone">提货电话</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.deliveryDate">发货日期</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.quantity">套数</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.shop">订货店铺</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.shippingClerk">发货员</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.shopPhone">订货电话</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.shipAddr">店铺地址</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.customerId">客户ID</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.customerName">客户姓名</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.customerPhone">客户电话</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.customerAddr">客户地址</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.customerBuy">第几次购买</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.payTime">付款时间</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.installRequirements">安装要求</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.remarks">备注</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.orderReceivPerson">接单客服</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.billingPerson">开单员</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.productionDate">生产日期</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.finishDateTime">完成时间</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.outputTime">出库时间</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.boxNum">打包数</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.woodNum">打框数</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.abnormalClass">异常类型</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.abnormalDesc">异常描述</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.inventory">库存数</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.partsNum">配件数量</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.cabinetArea">柜体面积</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.unitPrice">单价</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.cabinetCost">柜体费用</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.metalsCost">五金费用</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.outsideProductCost">外采费用</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.installCost">安装费用</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.packCost">物流费用</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.subjoinCost">附加费</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.doorPlankArea">门板面积</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.totalMoney">订单金额</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.paymentMethod">付款方式</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.prepay">现付</el-checkbox>
              <el-checkbox v-model="displayColumnSettingsObject.monthBond">月结</el-checkbox>
            </div>
            <div slot="footer" class="dialog-footer">
              <!-- <el-button size="small" @click="selectAllDisplayColumnOrCancelAll()">{{selectAllDisplayColumn == 0 ? "全选" : "取消全选"}}</el-button> -->
              <el-button type="primary" @click="displayColumnSettingsOk()">确定</el-button>
            </div>
          </el-dialog>
        </div>
        
      </div>
      
    </template>
    
<script>
  import { export_json_to_excel } from '../../assets/js/Export2Excel.js'
  export default {
    data() {
      return {
        queryInfo: {
          orderNo: "",
          beginOrderTime: "",
          endOrderTime: "",
          orderStatus: "",
          productName: "",
          shop: "",
          customerId: "",
          customerName: "",
          customerPhone: "",
          customerAddr: "",
          cancelExp: "",
          cancelPerson: "",
          beginCancelTime: "",
          endCancelTime: "",
          sortByFieldName: "cancel_time",
          sortType: false,
          pageNum: 1,
          pageSize: 10
        },
        scopeDateTime: null,
        scopeCancelTime: null,
        orderList: [],
        total: 0,
        pagePermissionObj: JSON.parse(window.localStorage.getItem("pagePermission")),
        //展示列设置模态窗口
        displayColumnSettingsDialogVisible: false,
        //展示列配置对象
        displayColumnSettingsObject: {
          orderNo: true,
          cancelExp: true,
          cancelTime: true,
          cancelPerson: true,
          orderDateTime: true,
          productName: true,
          speModel: true,
          colour: true,
          sheetMaterial: true,
          orderStatus: true,
          orderType: true,
          pickUpGoodsPhone: true,
          deliveryDate: true,
          quantity: true,
          shop: true,
          shippingClerk: true,
          shopPhone: true,
          shipAddr: true,
          customerId: true,
          customerName: true,
          customerPhone: true,
          customerAddr: true,
          customerBuy: true,
          payTime: true,
          installRequirements: true,
          remarks: true,
          orderReceivPerson: true,
          billingPerson: true,
          productionDate: true,
          finishDateTime: true,
          outputTime: true,
          boxNum: true,
          woodNum: true,
          abnormalClass: true,
          abnormalDesc: true,
          inventory: true,
          partsNum: true,
          cabinetArea: true,
          unitPrice: true,
          cabinetCost: true,
          metalsCost: true,
          outsideProductCost: true,
          installCost: true,
          packCost: true,
          subjoinCost: true,
          doorPlankArea: true,
          totalMoney: true,
          paymentMethod: true,
          prepay: true,
          monthBond: true,
        },
        selectAllDisplayColumn: 1,
      };
    },
    methods: {
      async getOrderList() {
        if(this.scopeDateTime != null)
        {
          this.queryInfo.beginOrderTime = this.scopeDateTime[0]
          this.queryInfo.endOrderTime = this.scopeDateTime[1]
        }
        else
        {
          this.queryInfo.beginOrderTime = ""
          this.queryInfo.endOrderTime = ""
        }
        
        if(this.scopeCancelTime != null)
        {
          this.queryInfo.beginCancelTime = this.scopeCancelTime[0]
          this.queryInfo.endCancelTime = this.scopeCancelTime[1]
        }
        else
        {
          this.queryInfo.beginCancelTime = ""
          this.queryInfo.endCancelTime = ""
        }
        
        this.queryInfo.orderNo = this.queryInfo.orderNo.replace(/\s+/g,'');
        this.queryInfo.productName = this.queryInfo.productName.replace(/\s+/g,'');
        this.queryInfo.shop = this.queryInfo.shop.replace(/\s+/g,'');
        this.queryInfo.customerId = this.queryInfo.customerId.replace(/\s+/g,'');
        this.queryInfo.customerName = this.queryInfo.customerName.replace(/\s+/g,'');
        this.queryInfo.customerPhone = this.queryInfo.customerPhone.replace(/\s+/g,'');
        this.queryInfo.customerAddr = this.queryInfo.customerAddr.replace(/\s+/g,'');
        this.queryInfo.cancelExp = this.queryInfo.cancelExp.replace(/\s+/g,'');
        this.queryInfo.cancelPerson = this.queryInfo.cancelPerson.replace(/\s+/g,'');
        
        const { data } = await this.$http.post("/api/order/get-cancel", this.queryInfo);
        if (data.code == 1) {
          this.orderList = data.data.dataList;
          this.total = data.data.total;
          this.totalPag = data.data.totalPag;
          
          //对接收公司隐藏订单销售金额
          if(this.orderList != null && this.orderList != undefined && this.orderList.length > 0)
          {
            for(let i = 0; i < this.orderList.length; i++)
            {
              if(this.orderList[i].receiverComCode == window.localStorage.getItem("userComCode"))
              {
                this.orderList[i].totalMoney = null;
                this.orderList[i].prepay = null;
                this.orderList[i].monthBond = null;
              }
            }
          }
        }
        
      },
      //搜索
      search()
      {
        this.getOrderList();
      },
      //改变排序
      changeSort(sortByFieldName)
      {
        if(this.queryInfo.sortByFieldName == sortByFieldName)
        {
          this.queryInfo.sortType = !this.queryInfo.sortType
        }else{
          this.queryInfo.sortByFieldName = sortByFieldName
          this.queryInfo.sortType = false
        }
        this.getOrderList();
      },
      //当某一列的表头被点击时会触发该事件
      headerClick(column, event)
      {
        switch(column.property) {
          case "orderNo":
            this.changeSort("order_no");
            break;
          case "orderStatus":
            this.changeSort("order_status");
            break;
          case "orderType":
            this.changeSort("order_type");
            break;
          case "orderDateTime":
            this.changeSort("order_date_time");
            break;
          case "shop":
            this.changeSort("shop");
            break;
          case "shippingClerk":
            this.changeSort("shipping_clerk");
            break;
          case "shopPhone":
            this.changeSort("shop_phone");
            break;
          case "shipAddr":
            this.changeSort("ship_addr");
            break;
          case "customerId":
            this.changeSort("customer_id");
            break;
          case "customerName":
            this.changeSort("customer_name");
            break;
          case "customerPhone":
            this.changeSort("customer_phone");
            break;
          case "customerAddr":
            this.changeSort("customer_addr");
            break;
          case "duty":
            this.changeSort("duty");
            break;
          case "deliveryDate":
            this.changeSort("delivery_date");
            break;
          case "productName":
            this.changeSort("product_name");
            break;
          case "colour":
            this.changeSort("colour");
            break;
          case "speModel":
            this.changeSort("spe_model");
            break;
          case "packingRequirements":
            this.changeSort("packing_requirements");
            break;
          case "logisticsMode":
            this.changeSort("logistics_mode");
            break;
          case "quantity":
            this.changeSort("quantity");
            break;
          case "totalMoney":
            this.changeSort("total_money");
            break;
          case "paymentMethod":
            this.changeSort("payment_method");
            break;
          case "prepay":
            this.changeSort("prepay");
            break;
          case "monthBond":
            this.changeSort("month_bond");
            break;
          case "installRequirements":
            this.changeSort("install_requirements");
            break;
          case "pickUpGoodsPhone":
            this.changeSort("pick_up_goods_phone");
            break;
          case "remarks":
            this.changeSort("remarks");
            break;
          case "orderReceivPerson":
            this.changeSort("order_receiv_person");
            break;
          case "billingPerson":
            this.changeSort("billing_person");
            break;
          case "productionDate":
            this.changeSort("production_date");
            break;
          case "cabinetArea":
            this.changeSort("cabinet_area");
            break;
          case "plateUnitPrice":
            this.changeSort("plate_unit_price");
            break;
          case "cabinetCost":
            this.changeSort("cabinet_cost");
            break;
          case "metalsCost":
            this.changeSort("metals_cost");
            break;
          case "outsideProductCost":
            this.changeSort("outside_product_cost");
            break;
          case "installCost":
            this.changeSort("install_cost");
            break;
          case "packCost":
            this.changeSort("pack_cost");
            break;
          case "subjoinCost":
            this.changeSort("subjoin_cost");
            break;
          case "partsNum":
            this.changeSort("parts_num");
            break;
          case "completionTime":
            this.changeSort("completion_time");
            break;
          case "responsibleParty":
            this.changeSort("responsible_party");
            break;
          case "abnormalClass":
            this.changeSort("abnormal_class");
            break;
          case "abnormalDesc":
            this.changeSort("abnormal_desc");
            break;
          case "outputTime":
            this.changeSort("output_time");
            break;
          case "outputMan":
            this.changeSort("output_man");
            break;
          case "printCount":
            this.changeSort("print_count");
            break;
          case "pushCom":
            this.changeSort("push_com");
            break;
          case "pushPerson":
            this.changeSort("push_person");
            break;
          case "pushDateTime":
            this.changeSort("push_date_time");
            break;
          case "receiverCom":
            this.changeSort("receiver_com");
            break;
          case "receivePerson":
            this.changeSort("receive_person");
            break;
          case "receiveStatus":
            this.changeSort("receive_status");
            break;
          case "receiveDateTime":
            this.changeSort("receive_date_time");
            break;
          case "processOffer":
            this.changeSort("process_offer");
            break;
          case "clearingStatus":
            this.changeSort("clearing_status");
            break;
          case "clearingTime":
            this.changeSort("clearing_time");
            break;
          case "chargeOffStatus":
            this.changeSort("charge_off_status");
            break;
          case "chargeOffPerson":
            this.changeSort("charge_off_person");
            break;
          case "chargeOffDateTime":
            this.changeSort("charge_off_date_time");
            break;
          case "cancelTime":
            this.changeSort("cancel_time");
            break;
          case "cancelPerson":
            this.changeSort("cancel_person");
            break;
          case "boxNum":
            this.changeSort("box_num");
            break;
          case "woodNum":
            this.changeSort("wood_num");
            break;
          case "sheetMaterial":
            this.changeSort("sheet_material");
            break;
          case "customerBuy":
            this.changeSort("customer_buy");
            break;
          case "payTime":
            this.changeSort("pay_time");
            break;
          case "signReceiveComName":
            this.changeSort("sign_receive_com_name");
            break;
          case "pushPrintCount":
            this.changeSort("push_print_count");
            break;
          case "cancelExp":
            this.changeSort("cancel_exp");
            break;
          default:
            return;
        }
      },
      handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        this.getOrderList();
      },
      handleCurrentChange(newPage) {
        this.queryInfo.pageNum = newPage;
        this.getOrderList();
      },
      // 选择
      handleSelectionChange(val) {
        this.multipleSelection = val;
        //console.log(val);
      },
      // 根据状态改变行样式
      tableRowClassName({row, rowIndex}) {
        var classname = "";
        
        if (row.orderStatus == "异常订单") {
          classname += 'warning-row2';
        }
        else if (row.orderType == "加急订单") {
          classname += 'warning-row';
        }
        /* else if (row.orderStatus !== "运输外包" && row.orderStatus !== "订单完成" && this.getNowDateInt() >= parseInt(row.deliveryDate.replace(new RegExp('-','g'),""))) {
          //到发货日期未发货的提醒
          return '';
        } */
        
        //选中行加背景色
        if(this.multipleSelection !== undefined)
        {
          for(let i = 0; i< this.multipleSelection.length; i++) {
            if(row.id === this.multipleSelection[i].id)
            {
              classname += 'selection-row';
            }
          }
        }
        
        return classname;
      },
      // 订单详情
      orderInfo(index, orderInfo){
        //console.log(index);
        //console.log(orderInfo);
        let routeData = this.$router.resolve({path: 'info', query: { orderId: orderInfo.id, pageUpPath: '/order/cancel-list', pageUpName: '作废订单' }});
        window.open(routeData.href, '_blank');
      },
      //还原订单
      async restoreOrder(){
        if(this.multipleSelection==undefined || this.multipleSelection.length == 0){
          this.$message.error('请选择要还原的订单！');
          return;
        }
        
        this.$confirm('对'+this.multipleSelection.length+'个作废的订单进行还原, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then( async () => {
            let errorCount = ""
            for( let i = 0; i < this.multipleSelection.length; i++)
            {
              const {data:res} = await this.$http.put('/api/order/modif', {id: this.multipleSelection[i].id, cancelCond: 0})
              if(res.code != 1)
              { 
                errorCount += this.multipleSelection[i].orderNo + ", "
              }
              else
              {
                //为该订单添加一条被还原的跟踪记录
                let tailInfo = {
                  orderNo: this.multipleSelection[i].orderNo,
                  status: "订单被还原",
                  tailTime: this.getNowFormatDateTime(),
                  operator: window.localStorage.getItem("userCompellation"),
                }
                const { data } = await this.$http.post("/api/order-tail/create", tailInfo)
              }
            }
            
            if(errorCount == "")
            {
              this.$message({
                message: this.multipleSelection.length+' 个订单还原成功！',
                type: 'success'
              });
            }
            else
            {
              alert("还原完成！其中 " + errorCount + "还原失败！" )
            }
            
            this.getOrderList();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });          
          });
      },
      /**
       *  格式数据
       *  @filterVal  格式头
       *  @tableData  用来格式的表格数据
       */
      formatJson(filterVal, tableData) {
          return tableData.map(v => {
              return filterVal.map(j => {
                      return v[j]
                  })
              }
          )
      },
      exportExcle()
      {
        if(this.multipleSelection==undefined || this.multipleSelection.length == 0){
          this.$message.error('请选择要导出的订单！');
          return;
        }
        
        var tHeader = ["订单编号","作废说明","作废时间","作废人","接单时间","产品名称","规格型号","颜色","板材材料","订单状态","订单类型","提货电话","发货日期","套数","订货店铺","发货员","订货电话","店铺地址","客户ID","客户姓名","客户电话","客户地址","备注","接单客服","开单员","生产日期","完成时间","出库时间","打包数","打框数","异常类型","异常描述","库存数","库存数","配件数量","柜体面积","单价","柜体费用","五金费用","外采费用","安装费用","物流费用","附加费","门板面积","订单金额","付款方式","现付","月结","付款时间","安装要求"]
        var filterVal = ["orderNo","cancelExp","cancelTime","cancelPerson","orderDateTime","productName","speModel","colour","sheetMaterial","orderStatus","orderType","pickUpGoodsPhone","deliveryDate","quantity","shop","shippingClerk","shopPhone","shipAddr","customerId","customerName","customerPhone","customerAddr","remarks","orderReceivPerson","billingPerson","productionDate","finishDateTime","outputTime","boxNum","woodNum","abnormalClass","abnormalDesc","inventory","inventory","partsNum","cabinetArea","unitPrice","cabinetCost","metalsCost","outsideProductCost","installCost","packCost","subjoinCost","doorPlankArea","totalMoney","paymentMethod","prepay","monthBond","payTime","installRequirements"]
        var filename = '作废订单列表_'+this.getNowFormatDateTime()
        var data = this.formatJson(filterVal, this.multipleSelection)
        export_json_to_excel({
            header: tHeader,
            data,
            filename
        })
      },
      //点击行触发，选中或不选中复选框
      handleRowClick(row, column, event){
        this.$refs.multipleTable.toggleRowSelection(row);
      },
      //双击行时
      rowDoublelClick(row, column, event){
        this.orderInfo(-1, row);
      },
      //展示列设置模态窗口打开
      displayColumnSettings()
      {
        this.displayColumnSettingsDialogVisible = true;
      },
      //展示列设置确认
      displayColumnSettingsOk()
      {
        window.localStorage.setItem("displayColumnSettingsObjectOrderCancelList", JSON.stringify(this.displayColumnSettingsObject))
        this.displayColumnSettingsDialogVisible = false;
      },
      //获取展示列配置对象
      getDisplayColumnSettingsObject()
      {
        let displayColumnSettingsObjectOrderCancelListJson = window.localStorage.getItem("displayColumnSettingsObjectOrderCancelList");
        if(displayColumnSettingsObjectOrderCancelListJson !== null)
        {
          this.displayColumnSettingsObject = JSON.parse(displayColumnSettingsObjectOrderCancelListJson);
        }
      },
      //展示列设置全选取消全选
      selectAllDisplayColumnOrCancelAll()
      {
        if(this.selectAllDisplayColumn == 0)
        {
          this.displayColumnSettingsObject = {
            orderNo: true,
            cancelExp: true,
            cancelTime: true,
            cancelPerson: true,
            orderDateTime: true,
            productName: true,
            speModel: true,
            colour: true,
            sheetMaterial: true,
            orderStatus: true,
            orderType: true,
            pickUpGoodsPhone: true,
            deliveryDate: true,
            quantity: true,
            shop: true,
            shippingClerk: true,
            shopPhone: true,
            shipAddr: true,
            customerId: true,
            customerName: true,
            customerPhone: true,
            customerAddr: true,
            customerBuy: true,
            payTime: true,
            installRequirements: true,
            remarks: true,
            orderReceivPerson: true,
            billingPerson: true,
            productionDate: true,
            finishDateTime: true,
            outputTime: true,
            boxNum: true,
            woodNum: true,
            abnormalClass: true,
            abnormalDesc: true,
            inventory: true,
            partsNum: true,
            cabinetArea: true,
            unitPrice: true,
            cabinetCost: true,
            metalsCost: true,
            outsideProductCost: true,
            installCost: true,
            packCost: true,
            subjoinCost: true,
            doorPlankArea: true,
            totalMoney: true,
            paymentMethod: true,
            prepay: true,
            monthBond: true,
          }
          
          this.selectAllDisplayColumn = 1;
        }
        else
        {
          this.displayColumnSettingsObject = {
            orderNo: false,
            cancelExp: false,
            cancelTime: false,
            cancelPerson: false,
            orderDateTime: false,
            productName: false,
            speModel: false,
            colour: false,
            sheetMaterial: false,
            orderStatus: false,
            orderType: false,
            pickUpGoodsPhone: false,
            deliveryDate: false,
            quantity: false,
            shop: false,
            shippingClerk: false,
            shopPhone: false,
            shipAddr: false,
            customerId: false,
            customerName: false,
            customerPhone: false,
            customerAddr: false,
            customerBuy: false,
            payTime: false,
            installRequirements: false,
            remarks: false,
            orderReceivPerson: false,
            billingPerson: false,
            productionDate: false,
            finishDateTime: false,
            outputTime: false,
            boxNum: false,
            woodNum: false,
            abnormalClass: false,
            abnormalDesc: false,
            inventory: false,
            partsNum: false,
            cabinetArea: false,
            unitPrice: false,
            cabinetCost: false,
            metalsCost: false,
            outsideProductCost: false,
            installCost: false,
            packCost: false,
            subjoinCost: false,
            doorPlankArea: false,
            totalMoney: false,
            paymentMethod: false,
            prepay: false,
            monthBond: false,
          }
          
          this.selectAllDisplayColumn = 0;
        }
      },
      //完全清除订单
      fullyClearOrder()
      {
        if(this.multipleSelection==undefined || this.multipleSelection.length == 0){
          this.$message.error('请选择要完全清除的订单！');
          return;
        }
        
        this.$confirm('完全清除'+this.multipleSelection.length+'个订单, 是否继续? 该操作会彻底删除订单及其相关所有数据, 且不可恢复, 请谨慎操作！！！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then( async () => {
            
            let fullyClearOrderList = [];
            
            for( let i = 0; i < this.multipleSelection.length; i++)
            {
              let orderIdAndOrderNo = {
                orderId: this.multipleSelection[i].id,
                orderNo: this.multipleSelection[i].orderNo,
              }
              
              fullyClearOrderList.push(orderIdAndOrderNo);
            }
            
            const {data:res} = await this.$http.post('/api/order/fully-clear-order', fullyClearOrderList)
            if(res.code == 1)
            { 
              this.$message.success(fullyClearOrderList.length+'个订单完全清除成功！');
            }
            else
            {
              alert(res.msg);
            }
            
            this.getOrderList();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });          
          });
      }
      
    },
    created() {
      this.getOrderList();
      this.getDisplayColumnSettingsObject();
      
      var that = this
      //当前页面监视键盘输入
      document.onkeydown = function(e) {//事件对象兼容
          let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
          //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40;回车13
          //回车搜索
          if (e1 && e1.keyCode == 13) {
              that.search();
          }
          else if(e1 && e1.keyCode == 37)
          {
            if(that.queryInfo.pageNum > 1)
            {
              that.handleCurrentChange(that.queryInfo.pageNum - 1)
            }
          }
          else if(e1 && e1.keyCode == 39)
          {
            if(that.queryInfo.pageNum < that.totalPag)
            {
              that.handleCurrentChange(that.queryInfo.pageNum + 1)
            }
          }
      }
    }
  };
</script>

<style>
.el-cascader {
  width: 100%;
}
.el-table .warning-row {
  color: #ff0000;
}.warning-row2 {
  color: #ffaa00;
}.warning-row3 {
  color: #0055ff;
}.selection-row {
    background-color: #fff5cc !important;
}.warning-rowselection-row {
  color: #ff0000;
  background-color: #fff5cc !important;
}.warning-row2selection-row {
  color: #ffaa00;
  background-color: #fff5cc !important;
}

.el-table__body tr:hover>td{
    background-color: #fff5cc!important;
  }
 
.el-table__body tr.current-row>td{
  background-color: #fff5cc!important;
}
</style>
